export const getMerchant = (api, id) => {
  return api.get(`api/merchants/${id}`).then((res) => {
    return res.data.data;
  });
};
